/* eslint-disable */
import React, { useEffect, useState } from "react";
import BossDialog from "../../components/BossDialog";
import { Form, FormElement } from "@progress/kendo-react-form";
import * as API from "../../framework/API/api"
import { ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import { Checkbox } from "@progress/kendo-react-inputs";
import { utility } from "../../framework/utility/utilityProvider";
import ToastNotification from "../../components/ToastNotification";

const MediaSubCategoryTypeEditForm = (props) => {

    const lang = useTranslation();

    const [mediaCategory, setMediaCategory] = useState([]);
    const [mediaCategoryType, setMediaCategoryType] = useState([]);


    const [dataItem, setDataItem] = useState({});

    useEffect(() => {
        loadcombo();
    }, [])


    const loadcombo = async () => {
        let mediaCategoryRes = await API.getDataLookup(ENTITYNAME.MediaCategory);
        setMediaCategory(mediaCategoryRes?.data.filter((x) => x.isLong == true));

        let mediaCategoryTypeRes = await utility.getMediaCategroyTypeWithMediaCategory()
        setMediaCategoryType(mediaCategoryTypeRes?.filter((x) => x.MediaCategory?.isLong == true));

        if (props.item.SID > 0 || props.item.copy) {
            
            setDataItem({
                Description: props.item.copy ? "Copy of " + props.item.Description : props.item.Description ?? "",
                MediaCategory: mediaCategoryRes.data?.find(obj => obj.SID == props.item?.MediaCategorySID),
                MediaCategoryType: mediaCategoryTypeRes?.find(obj => obj.SID == props.item?.MediaCategoryTypeSID),
                Archive: props.item.Archive ?? false
            })
        }

    }

    const isValid = () => {
        if (dataItem.Description === '' || dataItem.Description === undefined) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_description_error_message });
            return false;
        }
        if (!dataItem.MediaCategory || Object.keys(dataItem.MediaCategory).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_media_category_error_message });
            return false;
        }
        if (!dataItem.MediaCategoryType || Object.keys(dataItem.MediaCategoryType).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_media_category_type_error_message });
            return false;
        }
        return true;
    }


    const handleSubmit = async () => {

        if (isValid()) {
            const saveData = {
                SID: props.item.SID ?? 0,
                Description: dataItem.Description ?? '',
                MediaCategorySID: dataItem.MediaCategory.SID,
                MediaCategoryTypeSID: dataItem.MediaCategoryType.SID,
                Archive: dataItem.Archive ?? false
            }
            var res = await API.saveData(ENTITYNAME.MediaSubCategoryType, saveData);
            if (res.success) {
                let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.MEDIASUBCATEGORYTYPE, data: res.data, message: res.message };
                API.SaveLogs(logData);
                props.cancelEdit();
                utility.deleteLocalStorageItem(ENTITYNAME.MediaSubCategoryType);
                props.refresh();
                return;
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            }
        }
    }

    const onChange = (e) => {
        if(e.target.name == "MediaCategory"){
            setDataItem({ ...dataItem, MediaCategory : e.target.value, MediaCategoryType: {} });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    return (
        <>
            <BossDialog
                title={props.item.SID > 0 ? props.item.Description : `Create ${lang.media_sub_category_type_label}`}
                onClose={props.cancelEdit}
                width={"600px"}
            >
                <Form
                    render={() => (
                        <FormElement>
                            <div className="row">
                                <div className="col-12">

                                    <EditPageHeader showTitle={false} onSubmit={handleSubmit} onCancel={props.cancelEdit} />
                                    <div className="row mt-2">
                                        <div className="col-12">
                                            <label>{lang.description_label} *</label>
                                            <input
                                                name={"Description"}
                                                type="text"
                                                className="form-control form-control-sm"
                                                onChange={onChange}
                                                value={dataItem.Description}
                                            />
                                        </div>
                                        <div className="col-6 mt-2">
                                            <label>{lang.media_category_label} *</label>
                                            <DropDownList
                                                data={mediaCategory}
                                                name="MediaCategory"
                                                textField="Description"
                                                dataItemKey="_id"
                                                value={dataItem.MediaCategory}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="col-6 mt-2">
                                            <label>{lang.media_category_type_label} *</label>
                                            <DropDownList
                                                data={mediaCategoryType.filter((x) => x.MediaCategorySID == dataItem?.MediaCategory?.SID)}
                                                name="MediaCategoryType"
                                                textField="Description"
                                                dataItemKey="_id"
                                                value={dataItem.MediaCategoryType}
                                                onChange={onChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col mt-3">
                                            <Checkbox
                                                name={"Archive"}
                                                style={{ marginLeft: "5px", marginBottom: "20px", borderColor: "black" }}
                                                value={dataItem.Archive}
                                                onChange={onChange}
                                            />
                                            <label className="pl-1">{lang.archive}</label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </FormElement>
                    )}
                />
            </BossDialog>
        </>)
};

export default MediaSubCategoryTypeEditForm;